import EmailField from './EmailField';
export { EmailField };
export default EmailField;
